<template>
  <!-- 显示卫星介绍 -->
  <el-container>
    <el-main class="full-screen">
      <div class="detail-box">
        <el-row>
          <el-col :span="10"
            ><video width="620" height="360" controls>
              <source src="../assets/about.mp4" type="video/mp4" />
              <!-- 你可以添加多个<source>元素来支持不同的视频格式 -->
              Your browser does not support the video tag.
            </video></el-col
          >
          <el-col :span="2"></el-col>
          <el-col :span="10">
            <div v-if="lan === 'en'" style="text-align: left" class="mess">
              <p>
                The
                <span style="font-weight: bold"
                  >International Data Node (IDN)</span
                >
                is an essential part of the remote sensing satellite data
                service system of the China National Space Administration
                (CNSA), which is managed and operated by the Earth Observation
                System and Data Center (EOSDC) of CNSA. Through the IDN,
                cooperative institutions in other countries may obtain Chinese
                remote sensing satellite data products in the area authorized by
                CNSA and may distribute and provide data services to users in
                the authorized zone in an agreed form.
              </p>
              <p>
                The satellites available in the IDN cover several Chinese public
                welfare satellite series and commercial satellite series such as
                multispectral, hyperspectral, and radar. The IDN aims to improve
                the ability of countries to use, process, and apply Chinese
                remote sensing satellite data without access, and contribute to
                the sustainable development of all nations.
              </p>
              <p>
                <span style="font-weight: bold"
                  >International Data Node in Bangladesh (IDN-Bangladesh)</span
                >
                is cooperated by EOSDC from China and Jagannath University
                (JNU). Both signed the MoU on IDN-Bangladesh at Nov of 2023 and
                will release the service in 2024.
              </p>
              <p>
                JNU is in charge of node operation and user service inside
                Bangladesh.
              </p>
            </div>
            <div
              v-if="lan === 'meng'"
              style="text-align: left"
              class="mess lao-text-class"
            >
              <p>
                <span style="font-weight: bold"
                  >আন্তর্জাতিক ডেটা নোড (আইডিএন)</span
                >
                চীন জাতীয় মহাকাশ প্রশাসন (সিএনএসএ) এর দূরবীক্ষণ উপগ্রহ ডেটা
                সেবা সিস্টেমের অবিচ্ছিন্ন অংশ, যা সিএনএসএ-র ভূমি পর্যবেক্ষণ
                সিস্টেম এবং ডেটা সেন্টার (ইওএসডিসি) দ্বারা পরিচালিত এবং পরিচালিত
                হয়। আইডিএন মাধ্যমে, অন্যান্য দেশের সহযোগী প্রতিষ্ঠানরা সিএনএসএ
                দ্বারা অনুমোদিত অঞ্চলে চীনা দূরবীক্ষণ উপগ্রহ ডেটা পণ্য প্রাপ্ত
                করতে পারে এবং একটি আদম্য ফর্মে অনুমোদিত অঞ্চলের ব্যবহারকারীদের
                জন্য তথ্য পরিষেবা সরবরাহ করতে পারে।
              </p>
              <p>
                আইডিএনের উপলব্ধ উপগ্রহগুলি বহুস্রোত, বহুবর্ণসংকুল, এবং রেডার সহ
                চীনা সরকারি উপগ্রহ সিরিজ এবং বাণিজ্যিক উপগ্রহ সিরিজ রয়েছে।
                আইডিএনের লক্ষ্য হলো দেশগুলির চীনা দূরবীক্ষণ উপগ্রহ ডেটা ব্যবহার,
                প্রক্রিয়া এবং প্রয়োগ করার সক্ষমতা বৃদ্ধি করা, এবং সমস্ত
                জাতিগুলির সাস্থায়িত উন্নতির কাজে অবদান রাখা।
              </p>
              <p>
                <span style="font-weight: bold"
                  >বাংলাদেশে আন্তর্জাতিক ডেটা নোড (আইডিএন-বাংলাদেশ)</span
                >
                চীন এবং জগন্নাথ বিশ্ববিদ্যালয় (জেএনইউ) এর সহযোগিতা করে। উভয়ই
                2023 সালে আইডিএন-বাংলাদেশের মেমোরান্ডাম অফ আন্ডারস্ট্যান্ডিং
                (MoU) স্বাক্ষর করে এবং 2023 সালে সেবা উন্মুক্ত করে।
              </p>
              <p>
                জগন্নাথ বিশ্ববিদ্যালয় (জেএনইউ) বাংলাদেশের মধ্যে নোড অপারেশন এবং
                ব্যবহারকারী সেবা প্রদানে দায়িত্বশীল।
              </p>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-main>

    <el-footer class="myfoot">
      <el-row style="margin-top: 50px">
        <el-col :span="5">
          <img src="../assets/cpeos.png" style="height: 85%"
        /></el-col>

        <el-col :span="14">
          <el-row>
            <div class="ft2 mt-2">
              Copyright © 2011-2022 CHEOS All rights reserved.
              京ICP备20003293号-5 京公网安备11010502042296号&nbsp;&nbsp;&nbsp;
            </div>
          </el-row>
        </el-col>
        <el-col :span="5"> </el-col>
      </el-row>
    </el-footer>
  </el-container>
</template>

<script type="text/javascript">
import { getCurrentInstance, onMounted, ref } from "vue";
export default {
  setup() {
    const lan = ref("en");
    const { proxy } = getCurrentInstance();
    onMounted(() => {
      lan.value = proxy.$i18n.locale;
      proxy.$EventBus.on("changelanguage", onchangelanguage);
    });

    function onchangelanguage() {
      lan.value = proxy.$i18n.locale;
    }
    return { lan };
  },
};
</script>
<style scoped>
body {
  overflow-x: hidden;
}
p {
    margin: 0; /* 消除段落间的默认间距 */
    text-align: justify; /* 设置为两端对齐 */
  }
  
.myfoot {
  height: 200px !important;
  background-image: url("../assets/footerbackground.png");
  align-items: center;
}
.full-screen {
  background-image: url("../assets/two-bg.png") !important;
}

.ft1 {
  font-size: 1.875rem;
  font-family: GenSekiGothic TW TTF;
  font-weight: 800;
  color: white;
}
.ft2 {
  font-size: 0.875rem;
  font-family: GenSekiGothic TW TTF;
  font-weight: 400;
  color: white;
}
.ft3 {
  font-size: 1.475rem;
  font-family: GenSekiGothic TW TTF;
  font-weight: 600;
  color: blue;
}

.center-row {
  align-items: center;
  display: flex;
  justify-content: center; /* 水平居中 */
}

.t2 {
  font-size: 25px !important; /* 设置字体大小为18像素 */
}

.mess {
  font-size: 1.2rem;
  font-family: GenSekiGothic TW TTF;
  font-weight: 200;
}

.detail-box {
  width: 85vw;
  margin: 0 auto;
  padding: 10px; /* 可选，为内容添加内边距 */
  background-color: rgba(
    182,
    215,
    238,
    0.7
  ); /* 使用 RGBA 颜色定义，最后一个值 (0.5) 控制透明度，范围是 0 到 1 */
}
.divider {
  color: #333;
  background-color: #333;
  height: 2px;
}
.lao-text-class {
  word-wrap: break-word; /* 或 overflow-wrap: break-word; */
}
</style>
